<fuse-loading-bar></fuse-loading-bar>

<router-outlet></router-outlet>
